import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Layout, Menu, Typography, Button, Tooltip } from "antd";
import {
  DashboardOutlined,
  ShoppingCartOutlined,
  DollarOutlined,
  CreditCardOutlined,
  LogoutOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
} from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import ProfilePictureComponent from "./../profilePicture";

const { Sider, Content } = Layout;

const DefaultLayout = ({ children }) => {
  const initialCollapsed =
    localStorage.getItem("menuCollapsed") === "true" ? true : false;
  const [collapsed, setCollapsed] = useState(initialCollapsed);
  const [isVisible, setIsVisible] = useState(true);
  const { currentUser } = useSelector((state) => state.user);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // MOBILE STATE
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 900);

  useEffect(() => {
    const handleResize = () => {
      const isNowMobile = window.innerWidth < 900;
      setIsMobile(isNowMobile);
      if (!isNowMobile) setMobileMenuOpen(false);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    localStorage.setItem("menuCollapsed", collapsed);
  }, [collapsed]);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("persist:root");
    window.location.href = "/login";
  };

const isDriver = currentUser?.roles?.includes("Driver");

// ✅ Menu items
  const desktopMenuItems = isDriver
  ? [
      {
        key: "/portal",
        icon: <DashboardOutlined />,
        label: <Link to="/portal">Upload Photos</Link>,
      },
      {
        key: "/logout",
        icon: <LogoutOutlined />,
        label: "Logout",
        onClick: handleLogout,
      },
    ]
  : [
      {
        key: "/shipment",
        icon: <ShoppingCartOutlined />,
        label: <Link to="/shipment">Create Delivery</Link>,
      },
      {
        key: "/portal",
        icon: <DashboardOutlined />,
        label: <Link to="/portal">All Orders</Link>,
      },
      {
        key: "/transactions",
        icon: <DollarOutlined />,
        label: <Link to="/transactions">Transactions</Link>,
      },
      {
        key: "/checkout",
        icon: <CreditCardOutlined />,
        label: <Link to="/checkout">Payment</Link>,
      },
      {
        key: "/logout",
        icon: <LogoutOutlined />,
        label: "Logout",
        onClick: handleLogout,
      },
    ];

  const mobileMenuItems = desktopMenuItems;

  return (
    <>
      <Layout hasSider>
        {/* Mobile toggle button on the RIGHT */}
        {isMobile && !isMobileMenuOpen && (
          <Button
            icon={<MenuUnfoldOutlined />}
            onClick={() => setMobileMenuOpen(true)}
            style={{
              position: "fixed",
              top: 8,
              right: 35, // ✅ moved to right
              zIndex: 2000,
            }}
          />
        )}

        {/* Desktop Sidebar on the LEFT */}
        {!isMobile && (
          <Sider trigger={null} collapsible collapsed={collapsed}>
          {!collapsed && (
            <div className="user-profile">
              {currentUser && (
                <ProfilePictureComponent
                  user_id={currentUser?.user_id}
                  size={80}
                />
              )}
              <div className="mt-10">
                <Typography className="mb-10">
                  {currentUser?.name}
                </Typography>
              </div>
            </div>
          )}
            <Menu selectedKeys={[location.pathname]} items={desktopMenuItems} />
            <Button
              type="text"
              className={isVisible === true ? "" : "menuButton"}
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={() => setCollapsed(!collapsed)}
              style={{
                fontSize: "16px",
                width: 30,
                height: 30,
                position: "absolute",
              }}
            />
          </Sider>
        )}

        <Content
          style={{
            padding: "0 0px 0 0",
            minHeight: "100% !important",
          }}
        >
          {children}
        </Content>
      </Layout>

      {/* Mobile menu overlay */}
      {isMobile && isMobileMenuOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0, // ✅ Open from right side visually
            width: "90vw",
            height: "100vh",
            background: "#001529",
            zIndex: 1999,
            padding: "10px 0px",
            overflowY: "auto",
            color: "#fff",
          }}
        >
          <Button
            icon={<MenuFoldOutlined />}
            onClick={() => setMobileMenuOpen(false)}
            style={{
              position: "absolute",
              top: 16,
              right: 16,
              zIndex: 2001,
            }}
          />
          <Menu
            theme="dark"
            mode="inline"
            selectedKeys={[location.pathname]}
            style={{ borderRight: 0 }}
            onClick={({ key }) => {
              if (key === "/logout") handleLogout();
              setMobileMenuOpen(false);
            }}
            items={mobileMenuItems}
          />
        </div>
      )}
    </>
  );
};

export default DefaultLayout;
